import { Repository } from "./adapters/repository";

import * as constrainElements from "./useCases/constrainElements";
import * as removeConstraint from "./useCases/removeConstraint";
import * as editConstraint from "./useCases/editConstraint";
import * as retrieveElementConstraints from "./useCases/retrieveElementConstraints";
import * as retrieveConstraints from "./useCases/retrieveConstraints";
import * as retrieveConstraint from "./useCases/retrieveConstraint";

enum UseCases {
  constrainElements = "constrainElements",
  removeConstraint = "removeConstraint",
  editConstraint = "editConstraint",
  retrieveElementConstraints = "retrieveElementConstraints",
  retrieveConstraints = "retrieveConstraints",
  retrieveConstraint = "retrieveConstraint",
}

interface Core {
  [UseCases.constrainElements]: constrainElements.Interactor;
  [UseCases.removeConstraint]: removeConstraint.Interactor;
  [UseCases.editConstraint]: editConstraint.Interactor;
  [UseCases.retrieveElementConstraints]: retrieveElementConstraints.Interactor;
  [UseCases.retrieveConstraints]: retrieveConstraints.Interactor;
  [UseCases.retrieveConstraint]: retrieveConstraint.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.constrainElements]: constrainElements.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeConstraint]: removeConstraint.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editConstraint]: editConstraint.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveElementConstraints]:
      retrieveElementConstraints.createInteractor(dependencies.repository),
    [UseCases.retrieveConstraints]: retrieveConstraints.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveConstraint]: retrieveConstraint.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
